import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import ImageUploading from "react-images-uploading";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
	errorMessage: {
		color: "red",
		marginTop: theme.spacing(2),
	},

	uploadButton: {
		backgroundColor: theme.palette.primary.main,
		color: "white",
		"&:hover": {
			backgroundColor: theme.palette.primary.dark,
		},
	},
}));

const BannerUploader = ({
	handleImageUpload,
	image,
	setImageURL,
	handleDeleteImg,
	errorMes,
}) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const [images, setImages] = useState([]);
	const [localError, setLocalError] = useState("");

	const maxNumber = 1;
	const maxFileSize = 512000;
	const maxAcceptType = ["jpg", "jpeg", "png"];

	useEffect(() => {
		if (image) {
			setImages([{ dataURL: image }]);
		}
	}, [image]);

	const handleUpload = async (imageList) => {
		if (imageList.length > 0) {
			const file = imageList[0].file;
			if (file) {
				setLocalError("");
				try {
					await handleImageUpload({ file });
					setLocalError("");
				} catch (error) {
					console.error("Error uploading image:", error);
					setLocalError(t("labels.errors.uploadImage"));
				}
			}
		}
	};

	const handleUploadError = (errors) => {
		if (errors.maxFileSize) {
			setLocalError(t("labels.errors.fileTooLarge"));
		} else if (errors.acceptType) {
			setLocalError(t("labels.errors.unsupportedFormat"));
		} else {
			setLocalError(t("labels.errors.uploadImage"));
		}
	};

	const handleDelete = async (img) => {
		const name = img.split("/").pop();
		await handleDeleteImg({ id: Date.now(), name });
		setImageURL("");
		setImages([]);
	};

	return (
		<div>
			<Typography variant="h6">{t("labels.uploadBanner")}</Typography>

			<ImageUploading
				multiple={false}
				value={images}
				onChange={(imageList) => {
					setImages(imageList);
					handleUpload(imageList);
				}}
				maxNumber={maxNumber}
				maxFileSize={maxFileSize}
				acceptType={maxAcceptType}
				onError={handleUploadError}
			>
				{({
					imageList,
					onImageUpload,
					onImageRemove,
					isDragging,
					dragProps,
				}) => (
					<div>
						<Button
							className={classes.uploadButton}
							onClick={onImageUpload}
							{...dragProps}
						>
							{t("labels.uploadImage")}
						</Button>
						{imageList.length > 0 && (
							<div style={{ marginTop: 20 }}>
								{imageList.map((image, index) => (
									<div key={index} style={{ marginBottom: 10 }}>
										<img src={image.dataURL} alt="" width="100" />
										<Button
											variant="contained"
											color="secondary"
											onClick={() => handleDelete(image.dataURL)}
											style={{ marginLeft: 10 }}
										>
											{t("labels.delete")}
										</Button>
									</div>
								))}
							</div>
						)}
					</div>
				)}
			</ImageUploading>

			{(errorMes || localError) && (
				<Typography className={classes.errorMessage}>
					{errorMes || localError}
				</Typography>
			)}

			{images.length > 0 && (
				<Chip label={t("labels.imageReady")} style={{ marginTop: 20 }} />
			)}
		</div>
	);
};

export default BannerUploader;
